import { storeThemeMode } from '@/shared/services/theme';
import { useAppDispatch, useAppSelector } from '@/store';
import { setThemeMode } from '@/store/app.slice';

/**
 * Текущая схема и переключение светлая ↔ тёмная. Выбор фиксируется явно
 * (режим system после переключения больше не действует) и переживает перезагрузку.
 */
const useThemeToggle = (): { isDark: boolean; toggleTheme: () => void } => {
  const dispatch = useAppDispatch();
  const theme = useAppSelector((state) => state.app.theme);

  const isDark = theme === 'dark';

  const toggleTheme = (): void => {
    const nextTheme = isDark ? 'light' : 'dark';
    storeThemeMode(nextTheme);
    dispatch(setThemeMode({ mode: nextTheme, theme: nextTheme }));
  };

  return { isDark, toggleTheme };
};

export default useThemeToggle;
